import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Feedback, ServersLocations, BitcoinMiningUrlsV2} from 'components';
function _createMdxContent(props) {
  const _components = {
    a: "a",
    em: "em",
    h2: "h2",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://braiins.com/stratum-v2?utm_source=help",
        children: "Stratum V2"
      }), " is a new protocol for pooled mining that we developed in collaboration with Bitcoin developer Matt Corallo. It improves efficiency, prevents man-in-the-middle attacks, and will eventually enable miners to work on their own block templates. Stratum V2 is implemented in our firmware, Braiins OS and ", _jsx(_components.a, {
        href: "https://braiins.com/os/plus?utm_source=help",
        children: "Braiins OS"
      }), ", and will be the new open standard in mining. However, it is still possible to mine with Stratum V1 if you prefer."]
    }), "\n", _jsx(_components.p, {
      children: "You don’t have to specify an explicit port for Stratum V2 on Braiins Pool. The reason is that the protocol is still in development and we alternate between two default ports (3336 and 3337) across protocol upgrades. Simply use a Stratum V2 URL for your pool URL and it will work the same as a V1 URL."
    }), "\n", _jsx(_components.p, {
      children: "However, there is a new required element of the URL in the path and that is the public key advertised by the pool that the mining software uses to verify the authenticity of the mining endpoint that it connects to. This prevents man-in-the-middle-attacks that attempt to steal hashrate. Any such attempt results in failed verification and the software refuses to use the given pool entry."
    }), "\n", _jsx(_components.p, {
      children: "Braiins Pool servers are located all around the world. For better connection and lower latency, please use one of the location-specific URLs instead of the general URL."
    }), "\n", _jsx(_components.h2, {
      children: "Servers and ports"
    }), "\n", _jsxs(_components.p, {
      children: ["Configure your devices to start mining on Braiins Pool. You need to run our ", _jsx(_components.a, {
        href: "https://braiins.com/os/plus?utm_source=help",
        children: "Braiins OS"
      }), " firmware which supports Stratum V2 (stock manufacturing firmware currently does not support this new protocol)."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.strong, {
        children: ["Set old slushpool.com addresses (contains slushpool in the address) if you’re using BOS version older than 22.08.1 for successful application of 0% mining fee on Braiins Pool. ", _jsx(_components.em, {
          children: "Old addresses will work indefinitely"
        }), ". Set new braiins.com addresses otherwise"]
      }), "."]
    }), "\n", _jsx(BitcoinMiningUrlsV2, {}), "\n", _jsx(Feedback, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
